import { render, staticRenderFns } from "./DestinationListSelect.vue?vue&type=template&id=2fc056bc&scoped=true"
import script from "./DestinationListSelect.vue?vue&type=script&lang=ts"
export * from "./DestinationListSelect.vue?vue&type=script&lang=ts"
import style0 from "./DestinationListSelect.vue?vue&type=style&index=0&id=2fc056bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc056bc",
  null
  
)

export default component.exports